
/*
 * .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  .  .  .  . .  .  . .  .
    *    .       .       .       .       .       .       .       .       .       .       .       .
    *      . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
    *  .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
    *    . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
    *   .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
    *      8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
    *   . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
    *      8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
    *   . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
    *      @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
    *   .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
    *     .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
    *   .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
    *     .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
    *   .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
 *
 * Copyright FortyFix(c) 2024.
 * Title: prod.Caban.ts;
 * Path: ./src/environments/prod.Caban.ts;
 * Description: ;
 * Author: giovannibattistadellaporta;
 * Created at: 28/11/24, 15:57;
 * Updated at: 28/11/24, 15:57;
 *
 */

import { environment as Env } from './BaseEnvironments/Caban';
import { getModule, addModule } from './Utility/ModuleUtility';

var Environment = () => {
  var env = Env;
  env.apiUrl = 'https://www.caban.cloud/api';
  env.langPrefix =  './assets/i18n/'
  env.langSuffix = '.json'
  var Materiali = [
    { id: 71, label: 'Complementi' },
    { id: 72, label: 'Materiali' },
  ]
  env.ClientiAddOn.attivita = true;
  env.ClientiAddOn.CampiAggiuntivi.push(
    {
      modificabile: true,
      nome: 'Nazione',
      oggetti: ['nazione'],
      inputType: 'text',
      titleClass: 'control-label col-form-label',
      class: 'col-md-3',
      visibleifProhibited: true,
    }
  )

  var menuenv: any = { Menu: [] };
  Materiali.forEach(element => {
    menuenv.Menu = [{
      path: `materiali/list/${element.id}`,
      title: element.label,
      icon: "mdi mdi-barcode",
      capacita: ["gestione-prodotti"]
    }, ...menuenv.Menu];
  });
  menuenv.Menu = [
    {
      title: "Menu",
      class: "has-arrow",
      label: "Menu",
      extralink: true
    },
    {
      module: "Dashboard",
      path: "/shared/cruscotto",
      title: 'Cruscotto',
      icon: "mdi mdi-gauge",
      capacita: ["menu-dashboard"]
    },
    ...menuenv.Menu
  ];
  return addModule(menuenv, env)

};

export var environment = getModule(Environment());
